// © 2026 AttainIP Engineering
import { DetailGrid, type DetailRow } from './DetailGrid';

export function FeedbackDetail({ fb }: { fb: any }) {
  const rows: DetailRow[] = [
    ['feedback_id', fb.id],
    ['user_id', fb.user_id],
    ['user_email', fb.user_email],
    ['user_name', fb.user_name],
    ['rating', fb.rating != null ? `${fb.rating}/5` : null],
    ['comment', fb.comment],
    ['resource_type', fb.resource_type],
    ['resource_id', fb.resource_id],
    ['source_service', fb.source_service],
    ['created_at', fb.created_at ? new Date(fb.created_at).toLocaleString() : null],
    ['updated_at', fb.updated_at ? new Date(fb.updated_at).toLocaleString() : null],
  ];
  return <DetailGrid rows={rows} />;
}
